// ContactPage.jsx
import React, { useState } from 'react';
import styles from './support.module.css';
import { FaChevronDown} from 'react-icons/fa';
import HeaderBlack from '../../components/header/headerBlack/headerBlack';
import { MdOutlineMailOutline,MdPhoneIphone } from "react-icons/md";


const SupportPage = () => {
  const [requestType, setRequestType] = useState('');
  const [showRequestDropdown, setShowRequestDropdown] = useState(false);

  const requestTypes = [
    'Support technique',
    "Accompagnement sur l'utilisation de la plateforme ou application",
    "Demande d'information"
  ];

  return (
    <div className={styles.container}>
      <HeaderBlack/>
      <main className={styles.main}>
        <h1 className={styles.title}>Contactez-nous !</h1>
        
        <p className={styles.subtitle}>
          Prenez contact avec l'équipe Diamond et découvrez comment nous pouvons vous accompagner tout au long de votre parcours.
        </p>

        <div className={styles.contentContainer}>
            <div className={styles.infoContainer}>
            <div className={styles.contactInfoCard}>
                <h2 className={styles.contactInfoTitle}>Information de Contact</h2>
                <div className={styles.contactDetail}>
                <div className={styles.iconContainer}>
                    <MdOutlineMailOutline className={styles.icon} />
                </div>
                <div className={styles.detailContent}>
                    <p className={styles.detailLabel}>Email:</p>
                    <p className={styles.detailText}>contact@diamond-aligner.com</p>
                </div>
                </div>

                <div className={styles.divider}></div>

                <div className={styles.contactDetail}>
                <div className={styles.iconContainer}>
                    <MdPhoneIphone className={styles.icon} />
                </div>
                <div className={styles.detailContent}>
                    <p className={styles.detailLabel}>Tél/Whatsapp :</p>
                    <p className={styles.detailText}>+4917689739948</p>
                </div>
                </div>
            </div>
            </div>
        <div className={styles.formContainer}>
          <div className={styles.formContainer}>
            <div className={styles.formRow}>
              <input 
                type="text" 
                placeholder="Nom & Prénom" 
                className={styles.formInput} 
              />
              <input 
                type="email" 
                placeholder="Email" 
                className={styles.formInput} 
              />
            </div>

            <div className={styles.formRow}>
              <input 
                type="text" 
                placeholder="Objet / Commentaire:" 
                className={styles.formInputFull} 
              />
            </div>

            <div className={styles.formRow}>
              <div className={styles.dropdown}>
                <div 
                  className={styles.dropdownToggle}
                  onClick={() => setShowRequestDropdown(!showRequestDropdown)}
                >
                  {requestType || 'Type de requête :'} 
                  <FaChevronDown className={styles.dropdownIcon} />
                </div>
                {showRequestDropdown && (
                  <div className={styles.dropdownMenu}>
                    {requestTypes.map((type) => (
                      <div 
                        key={type} 
                        className={styles.dropdownItem}
                        onClick={() => {
                          setRequestType(type);
                          setShowRequestDropdown(false);
                        }}
                      >
                        {type}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className={styles.formRow}>
              <textarea 
                placeholder="Message" 
                className={styles.formTextarea}
                rows={8}
              />
            </div>
           
            <div className={styles.pagination}>
                 
              <div className={styles.paginationNumbers}>
                {/*
                <span 
                  className={`${styles.pageNumber} ${currentPage === 1 ? styles.active : ''}`}
                  onClick={() => setCurrentPage(1)}
                >
                  1
                </span>
                <span 
                  className={`${styles.pageNumber} ${currentPage === 2 ? styles.active : ''}`}
                  onClick={() => setCurrentPage(2)}
                >
                  2
                </span>
                <span 
                  className={`${styles.pageNumber} ${currentPage === 3 ? styles.active : ''}`}
                  onClick={() => setCurrentPage(3)}
                >
                  3
                </span>
                <span className={styles.pageNext}>Suivant</span>
                */}
              </div>
              
              <button className={styles.submitButton}>
                Envoyer
              </button>
            </div>
          </div>
        </div>
        </div>
      </main>
    </div>
  );
};

export default SupportPage;